@let currentItem = item();
<soft-ds-item
  variant="outline"
  size="sm"
  [interactive]="true"
  [class.is-focused]="focused()"
  (blur)="focused.set(false)"
  (activate)="activate.emit(currentItem)"
>
  <soft-ds-item-leading>
    <soft-icon [name]="currentItem.config.icon" size="sm" />
  </soft-ds-item-leading>
  <soft-ds-item-title [attr.title]="currentItem.config.title()">{{ currentItem.config.title() }}</soft-ds-item-title>
  <soft-ds-item-trailing
    class="sidebar-filter-trailing inline-flex items-center justify-center gap-2"
  >
    @if (isToggle()) {
      <!-- toggled via the row's activate; the switch itself is a passive indicator -->
      <soft-ds-switch class="page-filter-toggle"
                      size="sm"
                      [value]="toggleActive()"
                      [ariaLabel]="currentItem.config.title()"
                      data-testid="page-filter-toggle">
      </soft-ds-switch>
    }
    @else if (value(); as value) {
      <soft-ds-chip
        variant="primary-tinted"
        size="sm"
        maxWidth="var(--ds-spacing-27)"
        [attr.title]="valueText()"
        removable
        [removeLabel]="('#CORE_FILTER.LIST.CLEAR_FILTER' | translate) + ': ' + currentItem.config.title()"
        (remove)="clearFilter.emit(item())"
        data-testid="page-filter-list-item-chip"
      >
        @if (showsOperator()) {
          <ng-template softSlot="leading">
            <soft-filter-operator class="page-filter-list-item-operator" [operator]="value.operator" />
          </ng-template>
        }
        {{ valueText() }}
      </soft-ds-chip>
    }
    @if (!isToggle()) {
      <soft-ds-icon
        name="fa-regular fa-chevron-right"
        size="xs"
        color="secondary"
        aria-hidden="true"
        data-testid="page-filter-list-item-chevron"
      />
    }
  </soft-ds-item-trailing>
</soft-ds-item>
